module.exports = __webpack_public_path__ + "static/media/buildingConstruction36.269da257.jpg";